// deps
import React, { memo } from "react";
import classNames from "classnames";

// internal deps
import { AriaHidden } from "../../components/accessibility/aria-hidden";
import { withStyles } from "../../helpers/WithStyles";

// helpers
import { isEmpty } from "@swiggy-private/js-utils";

// styles
import styles from "./styles.scss";
import { IconContainer, StyledIcon } from "./PaymentMethodIcon.styles";

export interface PaymentMethodIconProps {
    /**
     * className to be applied on icon
     */
    className?: string;
    /**
     * Icon Image url
     */
    src?: string;
    /**
     * Icon Width
     */
    width?: number;
    alt?: string;
    poweredByIconAlt?: string;
    parentClassName?: string;
    imgClassName?: string;
    customLogo?: boolean;
    "data-testid"?: string;
    isThirdPartyDisabledIntentApp?: boolean;
    poweredByLogo?: string; // icon of the parent payment method, used for TWID
}

function PaymentMethodIcon(props: PaymentMethodIconProps): React.ReactElement | null {
    const { className, src, width, alt, isThirdPartyDisabledIntentApp, poweredByLogo = "", poweredByIconAlt } = props;
    if (className === undefined && src === undefined) {
        return null;
    }

    const showPoweredByLogo = !isEmpty(poweredByLogo);

    const iconClass = classNames(
        styles.iconContainer,
        {
            [styles.icon]: !props.customLogo,
        },
        props.parentClassName,
    );

    const imgClass = classNames(
        {
            [styles.iconImg]: !props.customLogo,
            [styles.grayScale]: isThirdPartyDisabledIntentApp,
            [styles.iconWithMaxWidth100]: !showPoweredByLogo,
        },
        props.imgClassName,
    );

    return (
        <AriaHidden as="div" className={iconClass} data-testid={props["data-testid"]}>
            {className !== undefined ? (
                <div className={className} />
            ) : (
                <>
                    <img alt={alt} crossOrigin="anonymous" className={imgClass} src={src} width={width} />
                    {showPoweredByLogo && (
                        <IconContainer>
                            <StyledIcon alt={poweredByIconAlt} crossOrigin="anonymous" src={poweredByLogo} />
                        </IconContainer>
                    )}
                </>
            )}
        </AriaHidden>
    );
}

export default memo<PaymentMethodIconProps>(withStyles(PaymentMethodIcon, styles));
